module.exports = "/_next/static/images/WhatDoesItTake-39c96216e0b037559c76be6469af13ad.png";